// Theme JavaScript for the Aiwa theme

document.addEventListener('DOMContentLoaded', function() {
  // Initialize all components
  initHeader();
  initSearchUI();
  initCartDrawer();
  
  // Add to cart functionality
  document.querySelectorAll('.js-add-to-cart').forEach(button => {
    button.addEventListener('click', handleAddToCart);
  });
});

// Header functionality
function initHeader() {
  const mobileNav = document.querySelector('.mobile-nav');
  const menuToggle = document.querySelector('.header__menu-toggle');
  const mobileNavClose = document.querySelector('.mobile-nav__close');
  const submenuToggles = document.querySelectorAll('.mobile-nav__submenu-toggle');
  
  if (menuToggle && mobileNav && mobileNavClose) {
    menuToggle.addEventListener('click', function() {
      mobileNav.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    });
    
    mobileNavClose.addEventListener('click', function() {
      mobileNav.classList.remove('is-active');
      document.body.style.overflow = '';
    });
  }

  if (submenuToggles.length) {
    submenuToggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const submenu = this.nextElementSibling;
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', !isExpanded);
        submenu.classList.toggle('is-active');
      });
    });
  }
}

function setupPredictiveSearch(input, resultsContainer, closeDropdown) {
  const ACTIVE_CLASS = 'search-dropdown__result-item--active';
  let debounceTimer = null;
  let abortController = null;
  let currentIndex = -1;

  const clearResults = () => {
    if (abortController) {
      abortController.abort();
      abortController = null;
    }
    currentIndex = -1;
    resultsContainer.innerHTML = '';
    resultsContainer.hidden = true;
  };

  const setLoading = () => {
    resultsContainer.hidden = false;
    resultsContainer.innerHTML = '<div class="search-dropdown__loading">Buscando...</div>';
  };

  const setMessage = (message) => {
    resultsContainer.hidden = false;
    resultsContainer.innerHTML = `<div class="search-dropdown__no-results">${message}</div>`;
    currentIndex = -1;
  };

  const formatAmount = (value) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(value);
    }
    return (value / 100).toFixed(2);
  };

  const sanitizePrice = (product) => {
    if (typeof product.price === 'string' && product.price.trim().length) {
      return product.price.replace(/<[^>]*>?/g, '').trim();
    }
    if (typeof product.price === 'number') {
      return formatAmount(product.price);
    }
    if (typeof product.price_min === 'number') {
      return formatAmount(product.price_min);
    }
    if (typeof product.price_min === 'string' && product.price_min.trim().length) {
      return product.price_min.replace(/<[^>]*>?/g, '').trim();
    }
    return '';
  };

  const getImageData = (product) => {
    if (product.image) return product.image;
    if (product.featured_image) return product.featured_image;
    if (Array.isArray(product.images) && product.images.length) return product.images[0];
    return null;
  };

  const normalizeImageUrl = (imageData) => {
    if (!imageData) return '';

    let url = '';
    if (typeof imageData === 'string') {
      url = imageData;
    } else {
      url = imageData.url || imageData.src || '';
    }

    if (!url) return '';
    if (url.startsWith('//')) {
      url = `https:${url}`;
    }

    if (url.includes('?')) {
      if (!/width=/.test(url)) {
        url += '&width=160&crop=center';
      }
    } else {
      url += '?width=160&crop=center';
    }

    return url;
  };

  const escapeHtml = (value) => {
    if (value == null) return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  };

  const escapeHtmlAttr = (value) => {
    return escapeHtml(value).replace(/"/g, '&quot;');
  };

  const truncateText = (text, limit = 68) => {
    if (typeof text !== 'string') return '';
    const trimmed = text.trim();
    if (trimmed.length <= limit) return trimmed;
    return `${trimmed.slice(0, limit - 1).trim()}…`;
  };

  const stripHtml = (value) => {
    return value.replace(/<[^>]*>?/g, '').trim();
  };

  const normalizePriceText = (value) => {
    if (typeof value === 'string' && value.trim().length) {
      return stripHtml(value);
    }
    if (typeof value === 'number') {
      return formatAmount(value);
    }
    return '';
  };

  const getPriceTexts = (product) => {
    const saleCandidates = [
      product.price,
      product.price_min,
      product.price_max,
      product.final_price,
      product?.variants?.[0]?.price
    ];

    const compareCandidates = [
      product.compare_at_price,
      product.compare_at_price_min,
      product.compare_at_price_max,
      product?.variants?.[0]?.compare_at_price
    ];

    const saleText = saleCandidates.map(normalizePriceText).find(Boolean) || '';
    let compareText = compareCandidates.map(normalizePriceText).find(Boolean) || '';

    if (compareText && saleText && compareText === saleText) {
      compareText = '';
    }

    return { saleText, compareText };
  };

  const parsePriceToNumber = (value) => {
    if (typeof value === 'number') {
      return value;
    }
    if (typeof value === 'string') {
      const digits = value.replace(/[^0-9]/g, '');
      if (!digits) return null;
      return parseInt(digits, 10);
    }
    return null;
  };

  const getDiscountPercentage = (product) => {
    const saleValue = [product.price, product.price_min, product.price_max, product.final_price]
      .map(parsePriceToNumber)
      .find(value => typeof value === 'number' && !Number.isNaN(value));

    const compareValue = [product.compare_at_price, product.compare_at_price_min, product.compare_at_price_max]
      .map(parsePriceToNumber)
      .find(value => typeof value === 'number' && !Number.isNaN(value));

    if (!saleValue || !compareValue || compareValue <= saleValue) {
      return null;
    }

    const rawDiscount = Math.round(((compareValue - saleValue) / compareValue) * 100);
    return rawDiscount > 0 ? rawDiscount : null;
  };

  const extractSkuFromProduct = (product) => {
    if (!product) return '';
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    return product?.sku || variants.find(variant => variant?.available)?.sku || variants[0]?.sku || '';
  };

  const appendSkuToNode = (node, sku) => {
    if (!node || !sku || node.querySelector('.predictive-search__title-sku')) return;
    const separator = document.createElement('span');
    separator.className = 'predictive-search__title-separator';
    separator.setAttribute('aria-hidden', 'true');
    separator.textContent = ' | ';

    const skuSpan = document.createElement('span');
    skuSpan.className = 'predictive-search__title-sku';
    skuSpan.textContent = sku;

    node.appendChild(separator);
    node.appendChild(skuSpan);
  };

  const populateMissingSkus = (products, container) => {
    products.forEach((product, index) => {
      const titleNode = container.querySelector(`.search-dropdown__result-title[data-result-index="${index}"]`);
      if (!titleNode) return;

      const initialSku = extractSkuFromProduct(product);
      if (initialSku) {
        if (titleNode.dataset.skuLoaded !== 'true') {
          appendSkuToNode(titleNode, initialSku);
          titleNode.dataset.skuLoaded = 'true';
        }
        return;
      }

      if (titleNode.dataset.skuLoading === 'true' || titleNode.dataset.skuLoaded === 'true') {
        return;
      }

      const productUrl = product?.url ? `${product.url.replace(/\?.*/, '')}.js` : (product?.handle ? `/products/${product.handle}.js` : '');
      if (!productUrl) return;

      titleNode.dataset.skuLoading = 'true';

      fetch(productUrl, { headers: { Accept: 'application/json' } })
        .then(response => (response.ok ? response.json() : null))
        .then(data => {
          if (!data) return;
          const sku = extractSkuFromProduct(data);
          if (!sku) return;
          appendSkuToNode(titleNode, sku);
          titleNode.dataset.skuLoaded = 'true';
        })
        .catch(error => {
          console.error('SKU fetch error:', error);
        })
        .finally(() => {
          titleNode.dataset.skuLoading = 'false';
        });
    });
  };

  const filterProductsByQuery = (products, query) => {
    if (!Array.isArray(products)) return [];
    const normalizedQuery = (query || '').toString().trim().toLowerCase();
    if (!normalizedQuery.length) return products;

    const skuMatches = [];
    const otherMatches = [];
    const seen = new Set();

    products.forEach(product => {
      if (!product) return;

      const productId = product.id || product.handle || product.url;
      if (productId && seen.has(productId)) return;

      const title = (product.title || '').toLowerCase();
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const variantTitles = variants.map(variant => (variant?.title || '').toLowerCase());
      const variantSkus = variants.map(variant => (variant?.sku || '').toLowerCase());

      const matchesTitle = title.includes(normalizedQuery) || variantTitles.some(value => value.includes(normalizedQuery));
      const matchesSku = variantSkus.some(value => value && value.includes(normalizedQuery));

      if (matchesSku) {
        skuMatches.push(product);
        if (productId) seen.add(productId);
      } else if (matchesTitle) {
        otherMatches.push(product);
        if (productId) seen.add(productId);
      } else if (!productId || !seen.has(productId)) {
        otherMatches.push(product);
        if (productId) seen.add(productId);
      }
    });

    const filtered = skuMatches.concat(otherMatches);
    return filtered.length ? filtered : products;
  };

  const renderResults = (products) => {
    if (!products || !products.length) {
      setMessage('No se encontraron productos');
      return;
    }

    const isMobile = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(max-width: 749px)').matches : false;
    const maxItems = isMobile ? 4 : 6;
    const itemsToRender = products.slice(0, Math.min(products.length, maxItems));

    if (!itemsToRender.length) {
      setMessage('No se encontraron productos');
      return;
    }

    const items = itemsToRender.map((product, index) => {
      const imageData = getImageData(product);
      const imageSrc = normalizeImageUrl(imageData);
      const imageAlt = (imageData && typeof imageData === 'object' && imageData.alt) ? imageData.alt : product.title;
      const { saleText, compareText } = getPriceTexts(product);
      const discountPercent = getDiscountPercentage(product);
      const badgeHtml = discountPercent ? `<span class="search-dropdown__badge">-${discountPercent}%</span>` : '';
      const originalTitle = product.title || '';
      const truncatedTitle = truncateText(originalTitle, 68);
      const displayTitle = isMobile ? truncatedTitle : originalTitle;
      const titleAttr = escapeHtmlAttr(originalTitle);
      const titleHtml = escapeHtml(displayTitle);

      const sku = extractSkuFromProduct(product);
      const skuHtml = sku ? `<span class="predictive-search__title-separator" aria-hidden="true"> | </span><span class="predictive-search__title-sku">${escapeHtml(sku)}</span>` : '';

      return `
        <a href="${product.url}" class="search-dropdown__result-item" data-search-result-item>
          <span class="search-dropdown__result-media">
            ${imageSrc ? `<img src="${imageSrc}" alt="${imageAlt.replace(/"/g, '&quot;')}">` : ''}
          </span>
          <span class="search-dropdown__result-info">
            <span class="search-dropdown__result-title" title="${titleAttr}" data-result-index="${index}"${sku ? ' data-sku-loaded="true"' : ''}>${titleHtml}${skuHtml}</span>
            ${(saleText || compareText) ? `
              <span class="search-dropdown__price-group">
                ${compareText ? `<span class="search-dropdown__price search-dropdown__price--compare">${escapeHtml(compareText)}</span>` : ''}
                ${saleText ? `<span class="search-dropdown__price search-dropdown__price--sale">${escapeHtml(saleText)}</span>` : ''}
              </span>
            ` : ''}
          </span>
          ${badgeHtml}
        </a>
      `;
    }).join('');

    resultsContainer.hidden = false;
    resultsContainer.innerHTML = items;
    currentIndex = -1;

    populateMissingSkus(itemsToRender, resultsContainer);
  };

  const requestResults = (query) => {
    if (!query) {
      clearResults();
      return;
    }

    if (abortController) {
      abortController.abort();
    }

    abortController = new AbortController();

    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'product',
      'resources[limit]': '10',
      'resources[options][fields]': 'title,product_type,variants.title,variants.sku,tag',
      'resources[options][image_size]': '160x160',
      'resources[options][image_ratio]': 'square'
    });

    fetch(`/search/suggest.json?${params.toString()}`, {
      signal: abortController.signal,
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        const products = data?.resources?.results?.products || [];
        const filteredProducts = filterProductsByQuery(products, query);
        renderResults(filteredProducts);
      })
      .catch(error => {
        if (error.name === 'AbortError') return;
        console.error('Predictive search error:', error);
        setMessage('Error al realizar la búsqueda. Intenta de nuevo.');
      });
  };

  const moveActive = (direction) => {
    const items = Array.from(resultsContainer.querySelectorAll('[data-search-result-item]'));
    if (!items.length) return;

    currentIndex += direction;
    if (currentIndex < 0) currentIndex = items.length - 1;
    if (currentIndex >= items.length) currentIndex = 0;

    items.forEach((item, index) => {
      if (index === currentIndex) {
        item.classList.add(ACTIVE_CLASS);
      } else {
        item.classList.remove(ACTIVE_CLASS);
      }
    });
  };

  input.addEventListener('input', () => {
    const value = input.value.trim();
    clearTimeout(debounceTimer);

    if (!value) {
      clearResults();
      return;
    }

    setLoading();
    debounceTimer = setTimeout(() => {
      requestResults(value);
    }, 220);
  });

  input.addEventListener('keydown', (event) => {
    const items = Array.from(resultsContainer.querySelectorAll('[data-search-result-item]'));

    if (event.key === 'ArrowDown') {
      if (!items.length) return;
      event.preventDefault();
      moveActive(1);
    } else if (event.key === 'ArrowUp') {
      if (!items.length) return;
      event.preventDefault();
      moveActive(-1);
    } else if (event.key === 'Enter') {
      if (currentIndex >= 0 && items[currentIndex]) {
        event.preventDefault();
        window.location.href = items[currentIndex].getAttribute('href');
      }
    } else if (event.key === 'Escape') {
      clearResults();
      if (typeof closeDropdown === 'function') {
        closeDropdown();
      }
    }
  });

  input.addEventListener('focus', () => {
    if (input.value.trim().length) {
      requestResults(input.value.trim());
    }
  });

  input.addEventListener('blur', () => {
    setTimeout(() => {
      clearResults();
    }, 150);
  });

  resultsContainer.addEventListener('mouseenter', () => {
    const items = resultsContainer.querySelectorAll('[data-search-result-item]');
    items.forEach(item => item.classList.remove(ACTIVE_CLASS));
    currentIndex = -1;
  });

  resultsContainer.addEventListener('mousedown', (event) => {
    const item = event.target.closest('[data-search-result-item]');
    if (!item) return;
    event.preventDefault();
    window.location.href = item.getAttribute('href');
  });

  return {
    clear: clearResults
  };
}

// Search UI (dropdown preferred, fallback to legacy modal if present)
function initSearchUI() {
  const searchToggles = document.querySelectorAll('.js-toggle-search');
  const dropdown = document.querySelector('.search-dropdown');
  const dropdownInput = document.querySelector('.search-dropdown__input');
  const dropdownResults = dropdown ? dropdown.querySelector('[data-search-results]') : null;
  const modal = document.getElementById('search-modal');
  const modalInput = document.querySelector('.search-modal__input');
  let predictiveControls = null;

  // Preferred: dropdown
  if (searchToggles.length && dropdown) {
    const closeDropdown = () => {
      dropdown.classList.remove('is-open');
      dropdown.setAttribute('aria-hidden', 'true');
      if (predictiveControls) predictiveControls.clear();
    };
    const openDropdown = () => {
      dropdown.classList.add('is-open');
      dropdown.setAttribute('aria-hidden', 'false');
      if (dropdownInput) setTimeout(() => dropdownInput.focus(), 80);
    };
    searchToggles.forEach(btn => {
      btn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        const isOpen = dropdown.classList.contains('is-open');
        if (isOpen) { closeDropdown(); } else { openDropdown(); }
      });
    });
    document.addEventListener('click', function(e){
      if (!dropdown.contains(e.target) && !e.target.closest('.js-toggle-search')) {
        closeDropdown();
      }
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeDropdown(); });

    if (dropdownInput && dropdownResults) {
      predictiveControls = setupPredictiveSearch(dropdownInput, dropdownResults, closeDropdown);
    }
    return; // do not attach modal listeners if dropdown is present
  }

  // Fallback: legacy modal
  if (searchToggles.length && modal) {
    searchToggles.forEach(toggle => {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const isActive = modal.classList.contains('is-active');
        modal.classList.toggle('is-active');
        if (!isActive && modalInput) {
          setTimeout(() => modalInput.focus(), 100);
        }
      });
    });
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        modal.classList.remove('is-active');
      }
    });
  }
}

// Cart drawer functionality
function initCartDrawer() {
  // const cartToggle = document.querySelector('.header__icon--cart');
  // const cartDrawer = document.querySelector('.cart-drawer');
  // const cartClose = document.querySelector('.cart-drawer__close');
  // const cartOverlay = document.querySelector('.cart-drawer__overlay');
  
  // if (cartToggle && cartDrawer) {
  //   cartToggle.addEventListener('click', function(e) {
  //     e.preventDefault();
  //     cartDrawer.classList.add('active');
  //     if (cartOverlay) cartOverlay.classList.add('active');
  //     document.body.style.overflow = 'hidden';
  //   });
    
  //   if (cartClose) {
  //     cartClose.addEventListener('click', function() {
  //       cartDrawer.classList.remove('active');
  //       if (cartOverlay) cartOverlay.classList.remove('active');
  //       document.body.style.overflow = '';
  //     });
  //   }
    
  //   if (cartOverlay) {
  //     cartOverlay.addEventListener('click', function() {
  //       cartDrawer.classList.remove('active');
  //       cartOverlay.classList.remove('active');
  //       document.body.style.overflow = '';
  //     });
  //   }
  // }
}

// Add to cart functionality
function handleAddToCart(event) {
  event.preventDefault();
  
  const form = event.target.closest('form');
  if (!form) return;
  
  const formData = new FormData(form);
  
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    updateCart();
    showAddToCartMessage();
    
    // Open cart drawer if it exists
    const cartDrawer = document.querySelector('.cart-drawer');
    const cartOverlay = document.querySelector('.cart-drawer__overlay');
    
    if (cartDrawer) {
      cartDrawer.classList.add('active');
      if (cartOverlay) cartOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
  });
}

// Update cart count and contents
function updateCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Update cart count
      const cartCountElements = document.querySelectorAll('[data-cart-count]');
      if (cartCountElements) {
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
        });
      }
      
      // Update cart drawer contents if it exists
      updateCartDrawerContents(cart);
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}

// Update cart drawer contents
function updateCartDrawerContents(cart) {
  const cartDrawerContents = document.querySelector('.cart-drawer__contents');
  if (!cartDrawerContents) return;
  
  if (cart.item_count === 0) {
    cartDrawerContents.innerHTML = '<p class="cart-drawer__empty">Your cart is empty</p>';
    return;
  }
  
  let html = '';
  
  cart.items.forEach(item => {
    html += `
      <div class="cart-item" data-cart-item-key="${item.key}">
        <div class="cart-item__image">
          <img src="${item.image}" alt="${item.title}">
        </div>
        <div class="cart-item__content">
          <h3 class="cart-item__title">${item.title}</h3>
          <p class="cart-item__variant">${item.variant_title || ''}</p>
          <div class="cart-item__quantity-wrapper">
            <button type="button" class="cart-item__quantity-button" data-quantity-minus>-</button>
            <input type="number" class="cart-item__quantity" value="${item.quantity}" min="1" data-quantity-input>
            <button type="button" class="cart-item__quantity-button" data-quantity-plus>+</button>
          </div>
        </div>
        <div class="cart-item__price">
          ${Shopify.formatMoney(item.final_line_price)}
        </div>
        <button type="button" class="cart-item__remove" data-remove-item>&times;</button>
      </div>
    `;
  });
  
  html += `
    <div class="cart-drawer__footer">
      <div class="cart-drawer__subtotal">
        <span class="cart-drawer__subtotal-label">Subtotal</span>
        <span class="cart-drawer__subtotal-price">${Shopify.formatMoney(cart.total_price)}</span>
      </div>
      <p class="cart-drawer__taxes">Taxes and shipping calculated at checkout</p>
      <a href="/checkout" class="button cart-drawer__checkout">Checkout</a>
      <button type="button" class="cart-drawer__continue">Continue shopping</button>
    </div>
  `;
  
  cartDrawerContents.innerHTML = html;
  
  // Add event listeners to cart drawer elements
  initCartDrawerEvents();
}

// Initialize cart drawer events
function initCartDrawerEvents() {
  const cartDrawer = document.querySelector('.cart-drawer');
  if (!cartDrawer) return;

  const quantityMinusButtons = cartDrawer.querySelectorAll('[data-quantity-minus]');
  const quantityPlusButtons = cartDrawer.querySelectorAll('[data-quantity-plus]');
  const quantityInputs = cartDrawer.querySelectorAll('[data-quantity-input]');
  const removeItemButtons = cartDrawer.querySelectorAll('[data-remove-item]');
  const continueShoppingButton = document.querySelector('.cart-drawer__continue');
  
  quantityMinusButtons.forEach(button => {
    button.addEventListener('click', function() {
      const input = this.parentNode.querySelector('[data-quantity-input]');
      if (input.value > 1) {
        input.value = parseInt(input.value) - 1;
        updateItemQuantity(input);
      }
    });
  });
  
  quantityPlusButtons.forEach(button => {
    button.addEventListener('click', function() {
      const input = this.parentNode.querySelector('[data-quantity-input]');
      input.value = parseInt(input.value) + 1;
      updateItemQuantity(input);
    });
  });
  
  quantityInputs.forEach(input => {
    input.addEventListener('change', function() {
      updateItemQuantity(this);
    });
  });
  
  removeItemButtons.forEach(button => {
    button.addEventListener('click', function() {
      const cartItem = this.closest('[data-cart-item-key]');
      const itemKey = cartItem.dataset.cartItemKey;
      
      removeCartItem(itemKey);
    });
  });
  
  if (continueShoppingButton) {
    continueShoppingButton.addEventListener('click', function() {
      const cartDrawer = document.querySelector('.cart-drawer');
      const cartOverlay = document.querySelector('.cart-drawer__overlay');
      
      if (cartDrawer) {
        cartDrawer.classList.remove('active');
        if (cartOverlay) cartOverlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }
}

// Update cart item quantity
function updateItemQuantity(input) {
  const cartItem = input.closest('[data-cart-item-key]');
  const itemKey = cartItem.dataset.cartItemKey;
  const quantity = parseInt(input.value);
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: itemKey,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(cart => {
    updateCart();
  })
  .catch(error => {
    console.error('Error updating item quantity:', error);
  });
}

// Remove item from cart
function removeCartItem(itemKey) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: itemKey,
      quantity: 0
    })
  })
  .then(response => response.json())
  .then(cart => {
    updateCart();
  })
  .catch(error => {
    console.error('Error removing item from cart:', error);
  });
}

// Show add to cart message
function showAddToCartMessage() {
  const message = document.createElement('div');
  message.classList.add('add-to-cart-message');
  message.textContent = 'Item added to cart';
  
  document.body.appendChild(message);
  
  setTimeout(() => {
    message.classList.add('active');
    
    setTimeout(() => {
      message.classList.remove('active');
      
      setTimeout(() => {
        document.body.removeChild(message);
      }, 300);
    }, 2000);
  }, 10);
}
